import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BlogModel } from 'src/app/nutrigenic/models/blog/blog-model';
import { BlogService } from 'src/app/nutrigenic/services/blog/blog.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';

@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BlogDetailComponent {
    blogModel: BlogModel = new BlogModel();
    blogsModel: BlogModel[] = [];
    allBlogsModel: BlogModel[] = [];

    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute, 
        private blogService: BlogService,
        private sizedetection: ResizeDetectionService
    ) {}

    mouseEnter(item: any) {
        item.is_hover = true;
    }
    mouseLeave(item: any) {
        item.is_hover = false;
    }

    widthImage:string = '';
    heightImage:string = '';
    ngOnInit(){
        this.route.queryParams.subscribe((params: any) => {
            this.blogModel.id = params.id;
            this.blogModel.title = params.title;
            this.blogModel.titleImage = params.titleImage;
            this.blogModel.date = params.date;
            this.blogModel.content = params.content;
            this.blogModel.content_substring = this.blogModel.RemoveHtmlTags(params.content).length>200 ? this.blogModel.RemoveHtmlTags(params.content).substring(0, 200) : this.blogModel.RemoveHtmlTags(params.content);
            this.blogModel.hashtags = params.hashtags;
            this.getBlogs();
        });
        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
            if (!this.isMobile) {
                this.widthImage = '580px';
                this.heightImage = '296px';
            } else {
                this.widthImage = '321px';
                this.heightImage = '210px';
            }
        });
    }
    
    getBlogs(){
        this.blogService.getBlogs().subscribe((response) => {
            response.body.data.forEach((item: any) => {
                var blogModel = new BlogModel();
                blogModel.id = item.id;
                blogModel.title = item.title;
                blogModel.titleImage = item.title_image;
                blogModel.content = item.content;
                blogModel.content_substring = blogModel.RemoveHtmlTags(item.content).length>200 ? blogModel.RemoveHtmlTags(item.content).substring(0, 200) : blogModel.RemoveHtmlTags(item.content);
                blogModel.date = item.date;
                blogModel.hashtags = item.hashtags;
                this.blogsModel.push(blogModel);
            });
            this.allBlogsModel = this.blogsModel.filter(x=>x.id != this.blogModel.id).slice(0,4);
        });
    }

    navigateToBlogDetail(item: any) {
        this.router
            .navigate(['/blogDetail'], { queryParams: item })
            .then(() => {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            })
            .catch(() => { });
    }

    formatDate(dateS: string) {
        let date = new Date(dateS);
        return (date.getDate().toString().length==1 ? ("0"+date.getDate().toString()) : date.getDate().toString()) + "/" + ((date.getMonth()+1).toString().length==1 ? ("0"+(date.getMonth()+1).toString()): (date.getMonth()+1).toString()) + "/" + date.getFullYear().toString()
    }
}

